export const HARD_REDIRECT_TRIGGERED = 'HARD_REDIRECT_TRIGGERED';
export const SCROLL_TO = 'SCROLL_TO';

export function scrollTo(x, y) {
  return {
    type: SCROLL_TO,
    payload: [x, y],
  };
}

export function triggerHardRedirect(url) {
  return {
    type: HARD_REDIRECT_TRIGGERED,
    url,
  };
}

export function triggerHardReload() {
  return triggerHardRedirect(window.location.href);
}



// WEBPACK FOOTER //
// ./src/actions/window.js